export default {
  US: 'US',
  CA: 'CA',
  GB: 'GB',
  FR: 'FR',
};
